import { Component, OnInit } from '@angular/core';
import { MgService } from 'src/app/services/mg.service';

@Component({
  selector: 'app-daily-phrase',
  templateUrl: './daily-phrase.component.html',
  styleUrls: ['./daily-phrase.component.scss']
})
export class DailyPhraseComponent implements OnInit {
  public showPhrase: string;
  public showPhraseAuthor: string;
  public isLoading: boolean = true;

  constructor(
    private mg: MgService,
  ) { }

  ngOnInit(): void {
    this.getNewPhrase();
  }

  public getNewPhrase() {
    this.mg.getPhrase()
    .subscribe(
      res => {
        this.processPhrase(res);
      }
    )
  }

  private processPhrase(rawPhrase: string) {
    let processedPhase: string = rawPhrase;
    processedPhase = processedPhase.replace('document.write("<b>', "")
      .replace('");', "")
      .replace('<br/>', "")
      .replace('<br/>', "");

    let processedPhaseArray: Array<string> = processedPhase.split("</b>");

    this.showPhrase = processedPhaseArray[0];
    this.showPhraseAuthor = processedPhaseArray[1];
    this.isLoading = false;
  }
}
